import React from "react";
import styles from "./PasswordInput.module.css";
import { FiEye, FiEyeOff } from "react-icons/fi";
const PasswordInput = ({ value,name='password', handleChange,label='Password', ...props }) => {
  const [showPass, setShowPass] = React.useState(false);
  return (
    <>
      <label className={styles.label}>{label}</label>
      <div className={styles.passwordWrap}>
        <input
          className={styles.input}
           type={showPass ? "text" : "password"}
          name={name}
          placeholder="Enter your password"
          value={value || ""}
          onChange={(e) => handleChange(e, "password")}
          {...props}
        />

        <button
          type="button"
          className={styles.eyeBtn}
          onClick={() => setShowPass((s) => !s)}
          aria-label={showPass ? "Hide password" : "Show password"}
          title={showPass ? "Hide password" : "Show password"}
        >
          {showPass ? <FiEye />:  <FiEyeOff /> } 
        </button>
      </div>
    </>
  );
};

export { PasswordInput };
